import React from 'react';
import Nav from './Nav';

const Home = () => {
  return (
    <div>
      <Nav />
      <section>
        <h1>Home</h1>
      </section>
    </div>
  )
}

export default Home
